import React from 'react';
import ReactDOM from 'react-dom';

import { ConfirmDialogProps } from './types';
import { useConfirmDialog } from './useConfirmDialog';
import styles from './ConfirmDialog.module.css';

/**
 * カスタム確認ダイアログコンポーネント
 * @param props コンポーネントのプロパティ
 * @returns モーダルダイアログのポータル
 */
const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  isOpen,
  title = '確認',
  message = '変更が保存されていません。このページから移動しますか？',
  confirmLabel = '続行する',
  cancelLabel = 'キャンセル',
  onConfirm,
  onCancel
}) => {
  // カスタムフックを使用してロジックを分離
  useConfirmDialog(isOpen, onCancel);
  
  // ダイアログが閉じている場合は何も表示しない
  if (!isOpen) return null;
  
  // ダイアログをポータル使用してbody直下に描画
  return ReactDOM.createPortal(
    <div 
      className={styles['confirm-dialog-overlay']} 
      onClick={onCancel}
      data-testid="confirm-dialog__overlay"
    >
      <div 
        className={styles['confirm-dialog-container']} 
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="confirm-dialog-title"
        data-testid="confirm-dialog__container"
      >
        <div className={styles['confirm-dialog-header']}>
          <h2 
            id="confirm-dialog-title" 
            className={styles['confirm-dialog-title']}
            data-testid="confirm-dialog__title"
          >
            {title}
          </h2>
          <button 
            className={styles['confirm-dialog-close-button']} 
            onClick={onCancel}
            aria-label="Close dialog"
            data-testid="confirm-dialog__close-button"
          >
            ×
          </button>
        </div>
        
        <div className={styles['confirm-dialog-content']}>
          <p 
            className={styles['confirm-dialog-message']}
            data-testid="confirm-dialog__message"
          >
            {message}
          </p>
        </div>
        
        <div className={styles['confirm-dialog-button-group']}>
          <button 
            className={styles['confirm-dialog-cancel-button']} 
            onClick={onCancel}
            data-testid="confirm-dialog__cancel-button"
          >
            {cancelLabel}
          </button>
          <button 
            className={styles['confirm-dialog-confirm-button']} 
            onClick={onConfirm}
            autoFocus
            data-testid="confirm-dialog__confirm-button"
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ConfirmDialog; 